import { NotificationsNoneRounded, OpenInNewRounded, ReportProblemOutlined } from '@mui/icons-material'
import { Badge, Typography, Button, IconButton } from '@mui/material'
import { useUncheckedAlarms } from '../../generic/hooks/useUncheckedAlarms'
import Alarms from '../../maintenance/alarms&notifications/alarms/Alarms'
import Notifications from '../../maintenance/alarms&notifications/notifications/Notifications'
import { useNavigate } from 'react-router'
import { useState } from 'react'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'
import { SmartDialog } from '../../generic/utilities/SmartDialog'
import { useAuthorization } from '../../generic/hooks/useAuthorization'
import { AUTOMATION_ALARMS_PERMISSION, alarmButtonCounts } from '../../maintenance/alarms&notifications/alarmSections'
import AlarmCountPill from './AlarmCountPill'

// The pill draws its own halves, so the MUI badge only positions it: no fill, no padding, no fixed size,
// and no wrapping (MUI's badge wraps by default, which is what broke the old two-number text).
const pillBadgeStyle = {
  '.MuiBadge-badge': {
    p: 0,
    minWidth: 0,
    height: 'auto',
    bgcolor: 'transparent',
    flexWrap: 'nowrap',
    // Anchored nearer the icon than MUI's 50%, so a wide pill does not run into what sits to its right.
    transform: 'scale(1) translate(35%, -50%)'
  }
}

const TopBarBadge = () => {
  const { t_ } = useSmartTranslation()
  const { uncheckedNotifications, alarmsBySection } = useUncheckedAlarms()
  const [dialogStatus, setDialogStatus] = useState({ open: false })
  const [dialogStatus2, setDialogStatus2] = useState({ open: false })
  const navigate = useNavigate()
  const isUserAuthorized = useAuthorization()
  // Story 162: the pending count of each section, separately (automation | general).
  const alarmCounts = alarmButtonCounts(alarmsBySection, isUserAuthorized(AUTOMATION_ALARMS_PERMISSION))
  const nothingPending = alarmCounts.automation === 0 && alarmCounts.general === 0

  const goto = (value) => {
    navigate(value)
  }

  const buttonGoToAlarms = {
    render: {
      fetchFunction: () => {
        return (
          <Button color='primary' onClick={() => { goto('maintenance/alarms'); setDialogStatus({ open: false }) }}>
            <OpenInNewRounded sx={{ fontSize: '1.2em' }} />
            <Typography sx={{ marginLeft: '0.4em', fontSize: '0.875rem' }}> {t_('VIEW ALL')}</Typography>
          </Button>
        )
      }
    }
  }

  const buttonGoToNotifications = {
    render: {
      fetchFunction: () => {
        return (
          <Button color='primary' onClick={() => { goto('/maintenance/notifications'); setDialogStatus2({ open: false }) }}>
            <OpenInNewRounded sx={{ fontSize: '1.2em' }} />
            <Typography sx={{ marginLeft: '0.4em', fontSize: '0.875rem' }}> {t_('VIEW ALL')}</Typography>
          </Button>
        )
      }
    }
  }

  const handleNotificationCLick = () => {
    setDialogStatus2({ open: true })
  }
  const handleAlarmCLick = () => {
    setDialogStatus({ open: true })
  }

  return (
    <>
      <SmartDialog
        closeCallback={() => setDialogStatus({ open: false })}
        accept={false}
        cancel={false}
        close
        renderComponent={<Alarms toolbar={buttonGoToAlarms} unChecked />}
        setOpen={dialogStatus.open}
      />
      <SmartDialog
        closeCallback={() => setDialogStatus2({ open: false })}
        accept={false}
        cancel={false}
        close
        renderComponent={<Notifications toolbar={buttonGoToNotifications} unChecked />}
        setOpen={dialogStatus2.open}
      />

      <div style={{ display: 'flex', justifyContent: 'center', width: '100px', marginLeft: '10px', marginRight: '10px' }}>
        <IconButton onClick={() => handleNotificationCLick()} disabled={!isUserAuthorized('NOTIFICATIONS')}>
          <Badge badgeContent={uncheckedNotifications} color='info'>
            <NotificationsNoneRounded />
          </Badge>
        </IconButton>
        <IconButton onClick={() => handleAlarmCLick()} disabled={!isUserAuthorized('ALARMS')}>
          <Badge
            badgeContent={<AlarmCountPill automation={alarmCounts.automation} general={alarmCounts.general} />}
            invisible={nothingPending}
            sx={pillBadgeStyle}
            data-testid='alarm-button-badge'
          >
            <ReportProblemOutlined />
          </Badge>
        </IconButton>
      </div>
    </>
  )
}
export default TopBarBadge
